import axios from "axios";
import Vue from "vue";
import { setupBaseInterceptors } from "../utils/axios";
import env from "../utils/env";

let apiBaseUrl = env.BASE_URL;
let nlpBaseUrl = env.NLP_BASE_URL;
let llmBaseUrl = env.LLM_BASE_URL;
let ragBaseUrl = env.RAG_BASE_URL;
let llmToken = env.LLM_TOKEN;
let uploadsBaseUrl = env.UPLOADS_URL;
let sessionManagerBaseUrl = env.SESSION_MANAGER_BASE_URL;
let gatewayBaseUrl = env.GATEWAY;
let twitterBaseUrl = env.TWITTER_SUBSCRIPTION_URL;
let licenceManagerBaseUrl = env.LICENCE_MANAGER_BASE_URL;
let cubeBaseUrl = env.CUBE_BASE_URL;
let voiceBaseUrl = env.VOICE_API;

// console.log(apiBaseUrl, nlpBaseUrl, env)

// Vue.prototype.$http = axios

const botId = localStorage.getItem("botId");

Vue.prototype.$http_noauth = axios.create({
  baseURL: apiBaseUrl,
  headers: {},
});

Vue.prototype.$http = axios.create({
  baseURL: apiBaseUrl,
});

Vue.prototype.$http_multipart = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "multipart/form-data; boundary=MultipartBoundry",
  },
});

Vue.prototype.$http_uploads = axios.create({
  baseURL: uploadsBaseUrl,
  headers: {
    "Content-Type": "multipart/form-data; boundary=MultipartBoundry",
  },
});

Vue.prototype.$http_without_base = axios.create({});

Vue.prototype.$http_bot = axios.create({
  baseURL: apiBaseUrl,
  params: {
    bot_id: botId,
  },
});

Vue.prototype.$http_nlp = axios.create({
  baseURL: nlpBaseUrl,
});

Vue.prototype.$http_nlp_bot = axios.create({
  baseURL: nlpBaseUrl,
  params: {
    "filter[bot_id]": botId,
  },
});

Vue.prototype.$http_llm = axios.create({
  baseURL: llmBaseUrl,
  headers: {
    Authorization: `Bearer ${llmToken}`,
  },
});

Vue.prototype.$http_rag = axios.create({
  baseURL: ragBaseUrl,
  headers: {
    Authorization: `Bearer ${llmToken}`,
  },
});

Vue.prototype.$http_session_manager = axios.create({
  baseURL: sessionManagerBaseUrl,
});

Vue.prototype.$http_gateway = axios.create({
  baseURL: gatewayBaseUrl,
});

Vue.prototype.$http_licence = axios.create({
  baseURL: licenceManagerBaseUrl,
});

Vue.prototype.$http_twitter = axios.create({
  baseURL: twitterBaseUrl,
});

Vue.prototype.$http_cube = axios.create({
  baseURL: cubeBaseUrl,
});

Vue.prototype.$http_voice = axios.create({
  baseURL: voiceBaseUrl,
});

setupBaseInterceptors(Vue.prototype.$http);
setupBaseInterceptors(Vue.prototype.$http_multipart);
setupBaseInterceptors(Vue.prototype.$http_uploads);
setupBaseInterceptors(Vue.prototype.$http_without_base);
setupBaseInterceptors(Vue.prototype.$http_bot);
setupBaseInterceptors(Vue.prototype.$http_nlp);
setupBaseInterceptors(Vue.prototype.$http_nlp_bot);
setupBaseInterceptors(Vue.prototype.$http_llm);
setupBaseInterceptors(Vue.prototype.$http_rag);
setupBaseInterceptors(Vue.prototype.$http_session_manager);
setupBaseInterceptors(Vue.prototype.$http_gateway);
setupBaseInterceptors(Vue.prototype.$http_licence);
setupBaseInterceptors(Vue.prototype.$http_twitter);
setupBaseInterceptors(Vue.prototype.$http_cube);
// setupBaseInterceptors(Vue.prototype.$http_voice);

// Custom interceptor for Session Manager APIs to return data
Vue.prototype.$http_session_manager.interceptors.response.use((response) => {
  return response.data;
});
